<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">注册</h4>
                </div>

                <div>
                  <vs-input name="username" icon-no-border icon="icon icon-user" icon-pack="feather"
                    placeholder="用户名(字母开头, 可包含数字和下划线, 5-12位)" v-model="username" class="w-full" :disabled="disabled" />

                  <vs-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                    placeholder="密码" v-model="password" class="w-full mt-4" :disabled="disabled" />
                  <div class="flex flex-wrap justify-between mt-5"></div>
                  <button type="submit">
                    <vs-button :disabled="disabled" @click="register()">注册</vs-button>
                  </button>
                  <router-link to="/login">
                    <vs-button class="float-right" type="border">已有账号, 直接登录</vs-button>
                  </router-link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import Utils from '@/utils/utils'
  export default {
    data() {
      return {
        username: '',
        password: '',
        checkbox_remember_me: false,
        msg: '',
        disabled: false
      }
    },
    mounted() {

    },
    methods: {
      showMsg(msg) {
        this.isShowMsg = true
        this.msg = msg
        setTimeout(() => {
          this.isShowMsg = false
          this.msg = ''
        }, 1500)
      },

      register() {
        const reg = /^[a-zA-Z0-9_-]{5,12}$/
        if (this.username === '' || !this.username) {
          this.openNotify('用户名不能为空')
        } else if (!reg.test(this.username)) {
          this.openNotify('用户名格式不正确')
        } else if (!this.password || this.password === '') {
          this.openNotify('密码不能为空')
        } else if (this.password.length < 7 || this.password.length > 16) {
          this.openNotify('密码为7-16位字符')
        } else {
          const app = this
          app.disabled = true
          let data = {
            username: this.username,
            password: this.password
          }
          data = JSON.stringify(data)
          data = Utils.encrypt(data)
          app.$auth.register({
            params: {
              data: data
            },
            success: res => {
              app.disabled = false
              console.log('res', res)
              this.openNotify(res.data.msg, 'success')
              setTimeout(() => {
                this.$router.push({
                  path: '/login'
                })
              }, 1200)
            },
            error: error => {
              app.disabled = false
              const resp = error + ''
              const missCode = 408 + ''
              if (resp.includes(missCode)) {
                this.openNotify('账号已存在')
              } else {
                this.openNotify('注册信息提交错误, 请稍后重试')
              }
            }
          })
        }
      },

      openNotify: function (msg, color = 'danger') {
        this.$vs.notify({
          position: 'bottom-center',
          color: color,
          title: '操作提示',
          text: msg
        })
      }
    }
  }

</script>

<style lang="scss">
  #page-login {
    .social-login-buttons {
      .bg-facebook {
        background-color: #1551b1;
      }

      .bg-twitter {
        background-color: #00aaff;
      }

      .bg-google {
        background-color: #4285f4;
      }

      .bg-github {
        background-color: #333;
      }
    }
  }

  button {
    border: none;
  }

</style>
